import React from "react";

import GeneralAccessManagement from "./GeneralAccess";
import EDocsViewManagement from "./View";

// Import utilities
import { isAllowedToDo } from 'permissions-hub';
import { ACCEPTED_PERMISSIONS } from "constants";
import { isReadOnly } from "validations";

const EDocsManagement = ({ permissions }) => {

  // Is read-only ?
  const isReadOnlyy = isReadOnly(permissions);

  // Check read permission
  const isAllowedToRead = isAllowedToDo(
    ACCEPTED_PERMISSIONS["read"],
    permissions,
  );

  // Check create permission
  const isAllowedToCreate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["create"],
    permissions,
  );

  // Check update permission
  const isAllowedToUpdate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["update"],
    permissions,
  );

  // Check delete permission
  const isAllowedToDelete = isAllowedToDo(
    ACCEPTED_PERMISSIONS["delete"],
    permissions,
  );
  
  // Pass EDocsViewManagement as a prop if isGeneralAccess is true
  const ManagementComponent = isReadOnlyy ? (
      <EDocsViewManagement />
    ) : (
      <GeneralAccessManagement
        isAllowedToRead={isAllowedToRead}
        isAllowedToCreate={isAllowedToCreate}
        isAllowedToUpdate={isAllowedToUpdate}
        isAllowedToDelete={isAllowedToDelete}
        EDocsViewManagement={EDocsViewManagement}
      />
    );

  return ManagementComponent;

};

export default EDocsManagement;